<template>
  <div class="pagination">
    <div>
      <button class="control" :disabled="isInFirstPage" @click="changePage(page - 1)"><i class="fa fa-arrow-left"></i></button>
      <button v-for="(p, index) in paginators" :key="index" class="page" @click="changePage(p)" :class="{'active': page ===  p}">{{p}}</button>
      <button class="control" :disabled="isInLastPage" @click="changePage(page + 1)"><i class="fa fa-arrow-right"></i></button>
    </div>
    <div v-if="showJumpPage" class="pages-jump">
      <span>Jump to page</span>
      <form @submit.prevent="validateJump">
        <input class="pages-jump__value" v-model="jumpValue" placeholder="..." />
        <button class="pages-jump__submit" :disabled="!isValidJumpValue">GO</button>
      </form>
      <span>of {{ hasMoreThanMaxPages ? `${totalPages}+` : totalPages}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'pagination',
  data () {
    return {
      jumpValue: ''
    }
  },
  props: {
    page: {
      type: Number,
      required: true
    },
    resultsPerPage: {
      type: Number,
      required: true
    },
    totalResults: {
      type: Number,
      required: true
    },
    showJumpPage: {
      type: Boolean,
      required: false,
      default: false
    },
    maxPages: {
      type: Number,
      required: false,
      default: 100
    }
  },
  methods: {
    changePage (pageToGo) {
      this.$emit('changePage', pageToGo)
    },
    validateJump () {
      if (this.jumpValue <= this.totalPages) this.changePage(parseInt(this.jumpValue))
    }
  },
  computed: {
    isValidJumpValue () {
      const page = parseInt(this.jumpValue)
      if (!page || typeof page !== 'number') return false
      return page > 0 && page <= this.totalPages
    },
    totalPages () {
      if (this.totalResults <= this.resultsPerPage) return 1
      return Math.min(this.maxPages, Math.ceil(this.totalResults / this.resultsPerPage))
    },
    hasMoreThanMaxPages () {
      if (this.maxPages < Math.ceil(this.totalResults / this.resultsPerPage)) {
        return true
      }
      return false
    },
    isInFirstPage () {
      return this.page === 1
    },
    isInLastPage () {
      return this.page === this.totalPages
    },
    hasLargePageNum () {
      if (this.page + 2 >= 1000) {
        return true
      }
      return false
    },
    paginators () {
      const firstPage = 1
      let lastPage = this.totalPages
      let paginators = []
      /* if currentPage is near firstPage */
      if (this.totalPages <= 5) {
        for (var i = 0; i < this.totalPages; i++) {
          paginators.push(i + 1)
        }
      } else {
        if (this.page - firstPage < 3) {
          for (let i = firstPage; i < Math.max(2 + 4, this.page + 2); ++i) {
            paginators.push(i)
          }
        } /* if currentPage is near lastPage */ else if (lastPage - this.page < 2) {
          // if on the last page
          if (this.isInLastPage) {
            paginators.push(this.page - 4, this.page - 3)
            if (this.hasLargePageNum) paginators.shift() // remove first element for large Page numbers
          } else { // not on the last page
            if (!this.hasLargePageNum) {
              paginators.push(this.page - 3)
            }
          }
          if (!this.hasLargePageNum) paginators.push(this.page - 2)
          for (let i = Math.min(lastPage - 2 + 4, this.page - 1); i < lastPage + 1; ++i) {
            paginators.push(i)
          }
        } /* if currentPage is in the middle */ else {
          if (!this.hasLargePageNum) paginators.push(this.page - 2)
          for (let i = this.page - 1; i < this.page + 3; ++i) {
            paginators.push(i)
          }
          if (this.hasLargePageNum) paginators.pop()
        }
      }
      return paginators
    }
  }
}
</script>
